import { api } from "../../../services/api"


export async function GravaLogB2B(vOperacaoEfetuada, vCNPJ) {
    try {
        await api.post(`/usuario/api/GravaLogB2B`,
            {
                vOperacaoEfetuada: vOperacaoEfetuada,
                vCNPJ: vCNPJ
            },
            {
                headers: { 'Content-Type': 'application/json' },
            }
        )
    } catch (error) {
        console.log('Erro em GravaLogB2B: ' + error)
    }
}